import React from 'react';
import PropTypes from 'prop-types';
import {
  FilterContainer,
  FilterOption,
} from '@components/search_filters/units';
import { useMultiSelect } from '../hooks';

const MultiSelect = ({
  availableOptions,
  handleClearSelection,
  id,
  name,
  onFilterUpdate,
  showClearButton = false,
  isLoading,
  selected,
  subtext,
}) => {
  const { selectedOptions, handleChange, resetSelected } =
    useMultiSelect(selected);

  const handleSubmit = (event) => {
    event.preventDefault();
    onFilterUpdate({ [id]: selectedOptions });
  };

  return (
    <FilterContainer
      handleClearSelection={handleClearSelection}
      handleClick={handleSubmit}
      isLoading={isLoading}
      showClearButton={showClearButton}
      subtext={subtext}
      title={`Select ${name.toLowerCase()}`}
    >
      <form onSubmit={handleSubmit}>
        <FilterOption
          key={`${id}_all`}
          label="Any"
          name={name}
          onChange={resetSelected}
          selected={selectedOptions.length === 0}
          type="checkbox"
          value=""
        />
        {availableOptions.map(([displayLabel, value]) => (
          <FilterOption
            key={`${id}_${value}`}
            label={displayLabel}
            name={name}
            onChange={handleChange}
            selected={selectedOptions.includes(value)}
            type="checkbox"
            value={value}
          />
        ))}
        <button className="ch-reader" type="submit">
          Done
        </button>
      </form>
    </FilterContainer>
  );
};

export default MultiSelect;

MultiSelect.propTypes = {
  availableOptions: PropTypes.array,
  handleClearSelection: PropTypes.func,
  id: PropTypes.string,
  isLoading: PropTypes.bool,
  name: PropTypes.string,
  onFilterUpdate: PropTypes.func,
  selected: PropTypes.array,
  showClearButton: PropTypes.bool,
  subtext: PropTypes.string,
};
